export default {"src":"/_next/static/media/right-arrow.fd3dd43f.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};